export const referenceByid = (state) => (referencieId) => {
    const ref = state.references
    return ref.filter(r => r.CA115CODREFERENCIA === referencieId)
}